<template>
    <div v-if="filename" class="application-form-document mb-3">
        <p class="form-label">{{ label }}</p>
        <a class="application-form-document-link d-inline-block w-auto" :href="url" target="_blank" rel="noopener noreferrer"><span class="bi bi-file-earmark-pdf-fill me-2"></span>{{ filename }}</a>
        <button class="btn btn-link btn-sm text-danger" type="button" @click="destroy">Remove</button>
    </div>
    <div v-else class="mb-3">
        <label :for="label" class="form-label">{{ label }} (PDF, Max. 16 MB) <span class="text-danger" v-if="required">*</span></label
        ><input type="file" :name="name" :id="label" class="form-control" />
        <small class="form-text" v-if="text">{{ text }}</small>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            filename: this.data.filename,
            label: this.data.label,
            url: this.data.url,
            delete_url: this.data.delete_url,
            name: this.data.name,
            text: this.data.text,
            required: this.data.required,
        };
    },
    methods: {
        destroy() {
            if (window.confirm('Are you sure you want to remove ' + this.filename + ' ?')) {
                axios.post(this.delete_url, { filename: this.filename, _method: 'delete' }).then(({ data }) => {
                    this.filename = null;
                });
            }
        },
    },
};
</script>
